var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXuc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#25AAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 9C15.1875 12.4172 12.4172 15.1875 9 15.1875C5.58281 15.1875 2.8125 12.4172 2.8125 9C2.8125 5.58225 5.58281 2.8125 9 2.8125C12.4172 2.8125 15.1875 5.58281 15.1875 9ZM13.0669 9.19463C13.0708 9.12431 13.0669 9.19462 13.0669 9.12319C13.0669 7.09425 11.5678 5.292 9.62325 4.98881V3.80756L8.36325 4.20019V4.98937C6.41981 5.292 4.93087 6.96938 4.93087 8.99719C4.93087 11.0728 6.489 12.7828 8.49937 13.0275V14.1908L9.75938 13.7981V12.9847C10.4545 12.8503 11.1026 12.5368 11.6394 12.0751C12.1761 11.6134 12.5831 11.0195 12.8199 10.3522H11.5144C11.2704 10.8086 10.9072 11.1901 10.4633 11.4561C10.0195 11.7221 9.5118 11.8626 8.99437 11.8626C8.27062 11.862 7.57388 11.5876 7.04412 11.0945C6.51437 10.6014 6.19085 9.92605 6.13856 9.20419L13.0674 9.19463H13.0669ZM6.32812 7.94812C6.53873 7.41262 6.90571 6.95295 7.38128 6.62898C7.85684 6.30502 8.41895 6.13177 8.99437 6.13181C9.56954 6.13231 10.1313 6.30586 10.6065 6.62989C11.0817 6.95392 11.4484 7.41344 11.6589 7.94869H6.32869L6.32812 7.94812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXuc);
export default __webpack_public_path__ + "static/media/xuc.532e4edc8948ebee384bf60712429be8.svg";
export { ForwardRef as ReactComponent };